export const TAL_AUTO_SUGGESTED = "talAutoSuggested";

export const TIME_SHEET_MENU_OPTIONS = [
  { title: "All Timesheet", value: "all" },
  { title: "Configure Timesheet", value: "configured" },
  {
    title: "Timesheet Activated",
    value: "isTimeSheetActive",
    key: "timeSheetActivated",
  },
  { title: "Time Off Request", value: "isTimeOff", key: "timeOff" },
];

export const PLAIN_HEADER_ROUTES = [
  "add-candidate-email",
  "add-candidate",
  "add-candidate-name",
  "candidate-number",
  "select-gig-type",
  "gig-title",
  "candidate-skill",
  "candidate-salary",
  "message-candidate",
  "location",
  "date",
  "start-date",
  "end-date",
  "start-shift",
  "end-shift",
  "working-hours",
  "about-yourself",
  "about-your-company",
  "create-your-first-job",
];
